/**
 * Custom hook to fetch SSR custom information using React Query.
 *
 * This hook retrieves data from a server-side rendered endpoint using an access token
 * and locale information. It utilizes the `useQuery` hook from React Query for data fetching
 * and caching.
 *
 * @deprecated This hook is deprecated and should not be used in new implementations. Consider using an alternative approach or updated API.
 *
 * @param {Object} requestOptions - Options to configure the React Query `useQuery` hook.
 * @returns {Object} - The result of the React Query `useQuery` hook, including the fetched data, status, and other properties.
 */
import {useAccessToken} from '@salesforce/commerce-sdk-react'
import {useQuery} from '@tanstack/react-query'
import {useAppOrigin} from '@salesforce/retail-react-app/app/hooks/use-app-origin'
import {getMrtApiBasepath} from '../ssr/helpers'
import fetch from 'cross-fetch'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const useGetSSRCustomInfo = (requestOptions) => {
    const {getTokenWhenReady} = useAccessToken()
    const {locale} = useMultiSite()
    const origin = useAppOrigin()

    async function getOrigin() {
        const token = await getTokenWhenReady()

        const headers = {
            authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        }

        const endpoint = origin + getMrtApiBasepath('/get-ssr-custom-info')
        const response = await fetch(`${endpoint}`, {
            headers,
        })
        const data = await response.json()

        return data
    }

    return useQuery(['useGetSSRCustomInfo', locale.id], () => getOrigin(), requestOptions)
}

export default useGetSSRCustomInfo
